import styled from 'styled-components';

export const ImageGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  align-content: center;
  gap: 12px;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
`;

export const ImageCard = styled.div<{ $isDragging?: boolean; $isDropTarget?: boolean }>`
  position: relative;
  flex: 0 0 140px;
  width: 140px;
  height: 140px;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid ${({ theme, $isDropTarget }) => {
    if ($isDropTarget) return '#1a4d4d';
    return theme.mode === 'dark' ? '#374151' : '#e5e7eb';
  }};
  background: ${({ theme }) => (theme.mode === 'dark' ? '#242a33' : '#f3f4f6')};
  opacity: ${({ $isDragging }) => ($isDragging ? 0.4 : 1)};
  transform: ${({ $isDragging }) => ($isDragging ? 'scale(0.96)' : 'scale(1)')};
  transition: opacity 0.15s ease, transform 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
  box-shadow: ${({ $isDropTarget }) => ($isDropTarget ? '0 0 0 2px rgba(26, 77, 77, 0.25)' : 'none')};
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
`;

export const ImageThumb = styled.div<{ $imageUrl: string }>`
  width: 100%;
  height: 100%;
  background-image: url('${({ $imageUrl }) => $imageUrl}');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

export const ImageOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.28) 0%,
    transparent 40%,
    transparent 60%,
    rgba(0, 0, 0, 0.28) 100%
  );
  pointer-events: none;
`;

export const OverlayActions = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  pointer-events: auto;
`;

export const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 8px;
  background: rgba(239, 68, 68, 0.92);
  color: #fff;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.1s ease;

  &:hover {
    background: #ef4444;
    transform: scale(1.05);
  }
`;

export const DragHandle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(36, 42, 51, 0.92)' : 'rgba(255, 255, 255, 0.92)')};
  color: ${({ theme }) => (theme.mode === 'dark' ? '#d1d5db' : '#4b5563')};
  cursor: grab;
  pointer-events: auto;

  &:active {
    cursor: grabbing;
  }
`;

export const FileList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
`;
